export const getLocalCache = (cacheKey, cacheDurationMs) => {
  const cached = localStorage.getItem(cacheKey);
  if (!cached) {
    return null;
  }

  try {
    const parsed = JSON.parse(cached);
    const now = Date.now();
    if (now - parsed.timestamp < cacheDurationMs) {
      return parsed.data;
    } else {
      localStorage.removeItem(cacheKey);
      return null;
    }
  } catch (err) {
    localStorage.removeItem(cacheKey);
    return null;
  }
};

export const setLocalCache = (cacheKey, data) => {
  const payload = {
    timestamp: Date.now(),
    data,
  };
  localStorage.setItem(cacheKey, JSON.stringify(payload));
};